import { Box, Button, Typography } from '@mui/material';
import type { ComponentType } from 'react';

export type SeeMoreAccountsButtonProps = {
  label: string;
  Icon: ComponentType<{ style?: React.CSSProperties }>;
  onClick: () => void;
  displayCount: number;
  totalCount: number;
  disabled?: boolean;
};

export function SeeMoreAccountsButton({
  label,
  Icon,
  onClick,
  displayCount,
  totalCount,
  disabled = false,
}: SeeMoreAccountsButtonProps) {
  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          onClick={onClick}
          disabled={disabled}
          disableRipple
          disableFocusRipple
          disableTouchRipple
          endIcon={<Icon style={{ fontSize: '16px' }} />}
          sx={{
            borderRadius: 2,
            backgroundColor: 'white',
            border: '1px solid',
            borderColor: 'primary.main',
            color: 'primary.main',
            fontSize: '14px',
            fontWeight: 500,
            height: '48px',
            width: 'fit-content',
            px: 3,
            gap: 1,
            '&.Mui-disabled': {
              borderColor: 'neutral.light',
              color: 'neutral.light',
              cursor: 'not-allowed',
              backgroundColor: 'white',
            },
          }}
        >
          {label}
        </Button>
      </Box>
      <Typography sx={{ fontSize: '14px', color: 'neutral.dark', mt: 1.5, textAlign: 'center' }}>
        Showing {displayCount} {displayCount === 1 ? 'result' : 'results'} of {totalCount}
      </Typography>
    </Box>
  );
}
